import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-appointment-success-dialog',
    templateUrl: './appointment-success-dialog.component.html',
    standalone: true,
    styleUrls: ['./appointment-success-dialog.component.scss']
})
export class AppointmentSuccessDialogComponent {
  data = inject<{
    name: string;
    date: string;
    time: string;
    duration: string;
}>(MAT_DIALOG_DATA);

  constructor() {}
}
